import { Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { ItemType } from './../../../../models/modules/itemType';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
//import { formComponentMapOptions } from '~/front-models/form-component-map';
import { ReceiveTransaction, ShipTransaction } from '~/front-models/transactionGrid';
import { ComponentBase } from '~/infrastructure/component-base';
import { GridFieldSummary } from '~/models/modules/gridField';
import { StockItemSummary } from '~/models/modules/item';
import { AccountsService } from '~/services/administration.ts/accounts';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationsService } from '~/services/modules/stocks/locations';
import { ReceiveTransactionsService } from '~/services/modules/stocks/receive-transactions';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { ReportViewerPopupComponent } from '../../../../shared/components/viewer/popup.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { InventoryForReturnSummaryDto, InventoryListing } from '~/models/modules/inventory';
import { InventoriesService } from '~/services/modules/stocks/inventories';
import { AdjustInventoryTransactionsService } from '~/services/modules/stocks/adjust-transactions';
import { DateInputCustomFormatPlaceholder, DateTimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { SysReceivesService } from '~/services/administration.ts/sysReceive';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';

import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { SysIssue } from '~/models/administration/sysIssue';
import { SysIssuesService } from '~/services/administration.ts/sysIssue';
import { PrintReceiptsService } from '~/services/administration.ts/print-receipts';
import { FormatService } from '~/services/administration.ts/format';
import { TransactionDateEditingService } from '~/services/modules/stocks/administration/transaction-date-editing';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { DatePipe, Location } from '@angular/common';
import { ItemsTypes } from '~/shared/enums/itemsTypes';
import { ZeroQuantitySettingsService } from '~/services/administration.ts/zero-quantity-settings';
import { ReportsService } from '~/services/modules/reports/reports';
import { FormatTypes } from '~/shared/enums/FormatTypes';
import { Router } from '@angular/router';
import { FileInfo, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { fileSources } from '~/shared/enums/fileSources';
import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { FileSelectedStream } from '~/models/modules/file';
import { FilesService } from '~/services/modules/stocks/files';

@Component({
    selector: 'app-stock-adjust-inventory',
    templateUrl: './adjust-inventory.html',
    styleUrls: ['./adjust-inventory.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockAdjustInventoryComponent extends ComponentBase implements OnInit {
  page: string = 'transaction-adjust-inventory';
  title: string = 'Adjust Inventory';
  showTextBox = false;
  _costFormat: string;
  _currentUser: UserSummary;
  _hasFieldControlLicense: boolean = false;
  _theme: string;
  _form: FormGroup;
  _barcodePopupForm: FormGroup;
  _barcodePopupFormFields: any = [];
  _invalidForm: boolean;
  _model: any;
  _selectedAccount = new FormControl();

  _uploadedStream: FileSelectedStream[] = [];
  _selectedExistingFiles: FileSelectedStream[] = [];
  _selectedDocumentsKeys: any[] = [];
  _allowedFileTypes: allowedFileTypes[] = [allowedFileTypes.excel, allowedFileTypes.pdf, allowedFileTypes.word];
  _file: File;
  _fileStream: any;
  _selectFile: boolean = false;
  _uploaderSelectMessage: string = 'Upload file..';
  _showDocumentsGrid: boolean = false;

  @ViewChild('kendo_uploader') upload: UploadComponent;

  _fileSelectedChanges(ev: SelectEvent) {
    ev.files.forEach((file: FileInfo) => {
      if (file.rawFile) {
        this._file = file.rawFile;
        const reader = new FileReader();
        reader.readAsDataURL(file.rawFile);

        reader.onloadend = () => {
          this._fileStream = reader.result;
          let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
            stream: reader.result,
            size: file.rawFile.size,
            type: file.rawFile.type,
            name: file.rawFile.name,
            fileSource: fileSources.inventoryAdjustTransaction,
            isNew: true
          });
          this._uploadedStream.push(_selectedFileModel);
        };
      }
    });
    this._selectFile = (ev.files && ev.files.length > 0);
  }

  _fileRemoveEventHandler(e: any) {
    let fileName = e.files[0].name;
    let delFile: FileSelectedStream = this._uploadedStream.find(f => f.name.toLowerCase() == fileName.toLowerCase());
    if (delFile != undefined) {
      let indx = this._uploadedStream.indexOf(delFile);
      this._uploadedStream.splice(indx, 1);
    }
    this._fileStream = null;
  }

  _onUploadClick() {
  }

  _sortingSelected = new FormControl('old');
  _quickScan = new FormControl();
  _defaultQuantity = new FormControl();
  _defaultDate = new FormControl();
  _autoCodeGeneration = new FormControl();
  _inventoryCode = new FormControl();
  _quantity = new FormControl();
  _expirationDate = new FormControl();
  _sites: any[];
  _sitesFiltered: any[];
  _locations: any[];
  _locationsFiltered: any[];
  _purchaseOrders: any[];
  _purchaseOrdersFiltered: any[];
  _vendors: any[];
  _vendorsFiltered: any[];
  _selectedStockItem = new FormControl();
  _items: any[];
  _itemsFiltered: any[];
  _inventoryGridData: any[] = []; //create Adjust Inventory Transaction class for the grid
  _itemType: 'standard' | 'batch' | 'serial' | 'serial-with-quantity' | 'non-inventory';
  _barcodePopupActive: boolean;
  _minDate: Date = new Date(1901, 1, 1);
  minDate: Date = new Date();
  _printReceipt = new FormControl();
  _showStocksGrid: boolean = false;
  _selectedStocks: StockItemSummary[] = [];
  _stockItemsGridColumns: GridFieldSummary[];
  _settingsPrintReceipt: any;
  transactionId: number;
  showReports: boolean = false;
  _selectedCallback = (args: { dataItem: any; }) => args.dataItem;
  receiveReports: any;
  _poPreference: any;
  _addNewStockSettingEnabled: boolean = true; //get from receive settings
  _itemFilter: string;
  _personIDtData: Array<string> = [
    'Person 1',
    'Person 2',
    'Person 3'
  ];
  _addClassActive: boolean = false;
  OpenSignAndProcessForm: boolean = false;
  OpenCreateShippingAndProcessForm: boolean = false;

  _inventories: InventoryForReturnSummaryDto[];
  _inventoriesFiltered: InventoryForReturnSummaryDto[];
  _selectedInventoriesFromGrid: any[] = [];
  _selectedInventoryItem = new FormControl();
  _showInventoriesGrid: boolean;
  _inventoryItemsGridColumns: GridFieldSummary[];
  _fromLocation = new FormControl();
  _gridExpDate: boolean;
  _receiveUDField1Show: boolean;
  _receiveUDField2Show: boolean;
  _receiveUDField3Show: boolean;
  _receiveUDFieldDate1Show: boolean;
  _receiveUDFieldDate2Show: boolean;
  _receiveUDFieldDate3Show: boolean;

  _adjustInventoryReports: any;
  _showReports: boolean = false;


  _pageState: PageState;
  _selectedLabelObjectCode: any;
  _editFormActive: boolean;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isMandatory: boolean = false;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _selectedAccountIds: any[] = [];
  _language: string = 'en';
  _page: string = 'adjustInventoryHistory';
  _gridFieldText: GridFieldTextSummary[];
  _gridFieldAuth: GridFieldAuthorization[];
  _customerAuth: GridFieldAuthorization;
  _salesOrderAuth: GridFieldAuthorization;
  _isTransaction: boolean = false;
  _onlyRequired: boolean = false;
  _hasRequired: boolean = false;
  _sysIssue: SysIssue;
  _transactionId: number;
  _additionalErrors: any[];



  _datePickerFormat: string;
  _dateLabelInput: DateInputCustomFormatPlaceholder = { year: 'YYYY', month: 'MM', day: 'DD', hour: '', minute: '', second: '' };

  _dateEnabled: boolean;
  _inventoriesallitems: InventoryListing[];
  quantityFormat: string;
  digitNumber: number;
  maxToMove: number;

  comboBoxpagingationParams = {
    currentItem: '0',
    totalbyPage: 20,
    search: '',
    page: 1,
    pagenumber: 1
  };
  itemFormLocationsFiltered: any[];
  itemFormLocations: any[];

  @ViewChild('new_quantity_input') quantityInput: NumericTextBoxComponent;
  @ViewChild('kendo_combo_Pack_list') kendoComboPackList: ComboBoxComponent;
  @ViewChild('Kendo_Input_Transaction_note') KendoInputTransactionnote: ElementRef;
  @ViewChild('kendo_combo_Person_ID') kendocomboPersonID: ComboBoxComponent;
  @ViewChild('Kendo_Input_Notes') KendoInputNotes: ElementRef;
  @ViewChild('kendo_combo_accounts') kendoComboAccounts: AccountsDropdownComponent;
  @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
  @ViewChild('kendo_combo_inventoryId') kendocomboInventoryID: ComboBoxComponent;
  @ViewChild('kendo_combo_from_location') kendoComboFromLocation: ComboBoxComponent;
  @ViewChild('expiration_date') kendoDateTimePickerExpDate: DateTimePickerComponent;
  @ViewChild('kendo_combo_Receipt_Report') selectReceiptReport: ComboBoxComponent;


  isGeneralInformationExpanded: boolean = true;
  isScanInventoryExpanded: boolean = true;


  costPriceFormatType: FormatTypes = FormatTypes.CostandPriceFormat;
  quantityFormatType: FormatTypes = FormatTypes.QuantityFormat;
  constructor(
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _accountsService: AccountsService,
    private _locationsService: LocationsService,
    private _receiveTransactionsService: ReceiveTransactionsService,
    private _stockItemsService: StockItemsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutComponent: LayoutComponent,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _gridFields: GridFieldsService,
    private _securityService: SecurityService,
    private _inventoriesService: InventoriesService,
    private _adjustInventoryService: AdjustInventoryTransactionsService,
    private _filesService: FilesService,
    private _sysReceivesService: SysReceivesService,
    private _sysIssuesService: SysIssuesService,
    private _printReceiptsService: PrintReceiptsService,
    private _formatService: FormatService,
    private _reportService: ReportsService,
    private quantityFormatsService: QuantityFormatsService,
    private _TransactionDateEditting: TransactionDateEditingService,
    private _zeroQuantitySettingsService: ZeroQuantitySettingsService,
    private _renderer2: Renderer2,
    private router: Router
  ) {
    super();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this.LoadData();

    this._getReceiveSettings();
    // this._gridFields
    //     .getGridFieldsByPage('stockItems')
    //     
    //     .subscribe((data: any) => {
    //         this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
    //     });

    // this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
    //     this._stockItemsGridColumns = gridColumns;
    // }));

    this._gridFields
      .getGridFieldsByPage('inventories')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('inventories', data);
      });
    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('inventories', (gridColumns) => {
      this._inventoryItemsGridColumns = gridColumns;
      // if (this._showInventoriesGrid == true) {
      //     this._showInventoriesGrid = false;
      // setTimeout(() => {
      //     this._showInventoriesGrid = true;
      // });
      //}

    }));
    this._currentUser = this._securityService.currentUser;
    this._securityService.getLicense().subscribe((data: any) => {
      this._hasFieldControlLicense = !!data?.general?.fieldControl;
    });
    this._pageState = PageState.ADD;
  }



  async LoadData() {
    this.quantityFormat = await this.quantityFormatsService.getQuantityFormatForNumericTextBox();
    this.digitNumber = await this.quantityFormatsService.getDigitNumber(this.quantityFormat);
  }
  closeTextbox(event: any) {
    //this.title=event.value;
    this._gridFields.EditPageTitle(this.page, event.value).subscribe((data: any) => {
      this.title = data.titleName;
      // this._sharedService.TitleChanged.emit(true);
    });
    this.showTextBox = false;
  }
  showTextbox() {
    this.showTextBox = true;
    //document.getElementById('titleTextBox').focus();
    //this.titleTextBox.nativeElement.focus();
  }

  ngOnInit() {
    this._gridFields.getPageByName(this.page).subscribe((data) => {
      if (data.titleName) {
        this.title = data.titleName;
      }
    });
    this._quantity.valueChanges.subscribe((x) => {
      if (x && this._selectedInventoryItem.value && this._autoCodeGeneration.value) {
        if (this._itemType === 'serial' || !this._inventoryCode.value) {
          this.runGenerateBarcode();
        }
      }
    });
    this._selectedInventoryItem.valueChanges.subscribe((x) => {
      if (x != null) {
        this._fromLocation.enable();
      } else {
        this._fromLocation.disable();
      }
    });
    this._fromLocation.valueChanges.subscribe((x) => {
      if (x != null) {
        this._quantity.enable();
      } else {
        this._quantity.disable();
      }
    });
    this._fromLocation.disable({ emitEvent: false });
    this._quantity.disable({ emitEvent: false });
    this._expirationDate.disable({ emitEvent: false });

    this._initForm();
    this._OpenAccount();


    this.loadLabels();
    this.getAuth();
    this.getCustomerAuth();
    this.getSalesOrderAuth();
    this._getSysIssue();

    this._printReceiptsService
      .getPrintReceipt()
      .subscribe((data) => {
        this._settingsPrintReceipt = data;
      });

    this._sortingSelected.valueChanges.subscribe((x) => {
      this._inventoryGridData.reverse();
    });

    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this.getDateEnabledOption();
  }
  _OpenAccount() {
    if (this._currentUser.isEnterprise) {
      setTimeout(() => {
        this.kendoComboAccounts.toggle(true);
        this.kendoComboAccounts.focus();
      });
    }
    else {
      setTimeout(() => {
        this.kendocomboInventoryID.toggle(true);
        this.kendocomboInventoryID.focus();
      });
    }
  }
  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }
  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }
  _selectStocksHandler(): void {
    this._showStocksGrid = true;
  }

  ExpandCollapseGeneralInfoWidget(isExpand: boolean) {
    this.isGeneralInformationExpanded = !isExpand;
  }
  // gridnewquantity(e: any) {
  //   if ((e.itemTypeId == ItemsTypes.Serial || e.itemTypeId == ItemsTypes.SerialwithQuantity) && e.currentQty === '0.0000') {
  //     return true
  //   }
  //   return false
  // }
  newquantityvalidate(e: any) {
    if (e.value == null) {
      return true;
    }
    // if (e != undefined && e.value.availability === 0 && e.value.stockitems.itemType.id === ItemsTypes.SerialwithQuantity) {
    //   this._quantity.setValue(0.0000);
    //   return true;
    // }
    return false;
  }

  ExpandCollapseScanInventoryWidget(isExpand: boolean) {
    this.isScanInventoryExpanded = !isExpand;
  }



  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _generateBarcodeClick() {
    this.runGenerateBarcode();
    if (this._itemType == 'serial') {
      setTimeout(() => {
        this._initBarCodePopupForm();
      }, 500);
    } else if (this._itemType == 'batch') {
      // this.expirationDateInput.focus();
    }
  }



  _handleSitesFilter(value: any) {
    this._sitesFiltered = this._sites.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }


  _handleVendorsFilter(value: any) {
    this._vendorsFiltered = this._vendors.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _loadLocationsDD(siteId: number) {
    return this._locationsService.getLocationListingBySite(siteId)
      .subscribe((data: any) => {
        this._locations = data;
        this._locationsFiltered = data;
      });
  }

  _handleLocationsFilter(value: any) {
    this._locationsFiltered = this._locations.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handlePurchaseOrdersFilter(value: any) {
    if (this._poPreference != 'notValidated') {
      this._purchaseOrdersFiltered = this._purchaseOrders.filter(
        (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
    }
  }

  _loadItemsDD(siteId: number, selectedItemId: number = null) {
    return this._stockItemsService.getStockItemsListingBySite(siteId)
      .subscribe((data: any) => {
        this._items = data;
        this._itemsFiltered = data;
        if (selectedItemId != null) {
          var newStock = this._items.filter(x => x.id == selectedItemId)[0];
          this.quantityInput.focus();
          setTimeout(() => {
            this._selectedStockItem.setValue(newStock);
            this._form.patchValue({
              selectedStock: { id: newStock.id, number: newStock.number }
            });
          });
        }
      });
  }

  _handleItemsFilter(value: any) {
    this._itemFilter = value;
    this._itemsFiltered = this._items.filter((item) => {
      return (item.number.toString().toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        item.description?.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        item.itemType.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    })
  }

  _handleItemsChange(value: any) {
    if (value != null) {
      setTimeout(() => {
        this.quantityInput.focus();
      });
    }
  }

  _addNewStock() {
    var value = this._itemFilter;
    if (this._addNewStockSettingEnabled && typeof value === 'string' && this._items.findIndex(item => item.number === value) == -1) {
      var _accountSites: any[] = [];
      _accountSites.push({
        siteId: this._form.get('site').value.id,
        accountId: this._selectedAccount.value.id
      });
      var model: any = {};
      model.number = value;
      model.itemTypeId = 1;
      model.costTypeId = 1;
      model.receiveUnitOfMeasureId = 1;
      model.inventoryUnitOfMeasureId = 1;
      model.issueUnitOfMeasureId = 1;
      model['fileIds'] = [];
      model['vendorIds'] = [];
      model['stockItemAlternateCodes'] = [];
      model['accountSites'] = _accountSites;
      this._stockItemsService
        .createStockItem(model)

        .subscribe((response: any) => {
          if (response != null && typeof response === 'number') {
            this._loadItemsDD(this._form.get('site').value.id, parseInt(response.toString()));
          }
        });
    }
  }

  _dateChanged(selectedDate: Date) {
    if (selectedDate >= this._minDate) {
      this._expirationDate.value;
      this._quantitySubmited();
    }
  }

  _quantitySubmited() {

    switch (this._itemType) {
      case 'serial':
        if (this._inventoryCode.value == "" || this._inventoryCode.value == null) {
          var generateBarcodeRan = false;
          if (this._selectedInventoryItem.value && this._autoCodeGeneration.value) {
            this.runGenerateBarcode();
            generateBarcodeRan = true;
          }
          if (generateBarcodeRan) {
            setTimeout(() => {
              this._initBarCodePopupForm();
            }, 500);
          } else {
            this._initBarCodePopupForm();
          }
          return;
        }
        break;
    }

    if (this._selectedInventoryItem.value && this._fromLocation.value && this._quantity.value >= 0) {
      this.fillGrid();
      this._onClear(true);
    }
    else if (!this._selectedInventoryItem.value) {
      this._layoutComponent.openPopup({
        message: 'Please select an inventory',
        withoutConfirm: true
      });
    }
    else if (!this._fromLocation.value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select a location',
        withoutConfirm: true
      });
    }
    else if (this._quantity.value < 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please add new quantity',
        withoutConfirm: true
      });
    }
  }

  notValidreceiveUDFieldDate: boolean = false;

  async _saveTransactionFiles(): Promise<number[]> {
    let newFiles = [...this._uploadedStream];
    let existingFiles = [...this._selectedExistingFiles];

    if ((newFiles != undefined && newFiles.length > 0) || (existingFiles != undefined && existingFiles.length > 0)) {
      let _filesModel: any[] = [];
      newFiles.forEach(n => {
        let model: any = {};
        model.stream = n.stream;
        model.size = n.size;
        model.type = n.type;
        model.name = n.name ? n.name.substring(0, n.name.lastIndexOf('.')) : '';
        model.exension = n.name.substring(n.name.lastIndexOf(".") + 1).toLowerCase();
        model.typesToChecks = this._allowedFileTypes;
        model.existingFileId = n.existingFileId;
        model.fileSourceId = fileSources.inventoryAdjustTransaction;
        _filesModel.push(model);
      });

      let response = await this._filesService
        .createFileRange(_filesModel)
        .toPromise();

      if (response != null) {
        existingFiles.forEach((v) => {
          let ext = response.find(r => r == v.existingFileId);
          if (ext == undefined) {
            response.push(v.existingFileId);
          }
        });
        return response;
      }
    }
    return [];
  }

  async _onSave(e: any) {
    this.transactionId = null;
    const datepipe: DatePipe = new DatePipe('en-US')
    if (!this._inventoryGridData.length) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please add the items you want to Adjust.',
        withoutConfirm: true
      });
    } else if (!this.checkInventoriesValiation()) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please fill the required fields in the grid.',
        withoutConfirm: true
      });
    } else if (this._form.invalid) {
      this._invalidForm = true;
    } else {
      this._invalidForm = false;

      let fileIds: number[] = [];
      if (this._uploadedStream.length > 0 || this._selectedExistingFiles.length > 0) {
        fileIds = await this._saveTransactionFiles();
      }

      this._saveAdjustTransaction(fileIds);
    }
  }

  private _saveAdjustTransaction(fileIds?: number[]) {
    const formModel = this._form.value;
    let model: any = {};
    model['entryDate'] = formModel.date ?? this._form.get('date')?.value;
    model['notes'] = formModel.note;
    model['inventories'] = this._inventoryGridData.map((x) => {
      return {
        siteId: formModel.site,
        stockItemId: x.stockId,
        stockId: x.stockId,
        currentQuantity: Number(x.currentQty),
        newQuantity: Number(x.newQty),
        locationId: x.selectedFromLocation.id,
        notes: x.note,
        expirationDate: x.expDate !== 'Invalid Date' && x.expDate != null ? new Date(x.expDate).toLocaleString() : null,
        inventoryNumber: x.inventoryCode,
        fromLocationId: x.locationId,
        uDField1: x.uDField1,
        uDField2: x.uDField2,
        uDField3: x.uDField3,
        uDFieldDate1: x.uDFieldDate1 !== 'Invalid Date' ? new Date(x.uDFieldDate1).toLocaleString() : null,
        uDFieldDate2: x.uDFieldDate2 !== 'Invalid Date' ? new Date(x.uDFieldDate2).toLocaleString() : null,
        uDFieldDate3: x.uDFieldDate3 !== 'Invalid Date' ? new Date(x.uDFieldDate3).toLocaleString() : null
      };
    });

    model.inventories.forEach((element: any) => {
      if (element.uDFieldDate1 === 'Invalid Date') {
        element.uDFieldDate1 = null;
      }
      if (element.uDFieldDate2 === 'Invalid Date') {
        element.uDFieldDate2 = null;
      }
      if (element.uDFieldDate3 === 'Invalid Date') {
        element.uDFieldDate3 = null;
      }
      if (element.expirationDate === 'Invalid Date') {
        element.expirationDate = null;
      }
      if (element.expDate === 'Invalid Date') {
        element.expDate = null;
      }
    });

    if (this._receiveUDFieldDate1Show || this._receiveUDFieldDate2Show || this._receiveUDFieldDate3Show) {
      const inValidItem = this._inventoryGridData.find((x: any) =>
        (x.uDFieldDate1 == null || x.uDFieldDate2 == null || x.uDFieldDate3 == null));
      this.notValidreceiveUDFieldDate = inValidItem != undefined ? true : false;
    }

    if (fileIds && fileIds.length > 0) {
      model['stockAdjustTransactionFiles'] = fileIds.map((v) => {
        return { fileId: v, FileId: v };
      });
      model['stockAdjustFiles'] = fileIds.map((v) => {
        return { fileId: v, FileId: v };
      });
      model['fileIds'] = fileIds;
    } else {
      model['stockAdjustTransactionFiles'] = null;
      model['stockAdjustFiles'] = null;
    }

    this._adjustInventoryService
      .createAdjustInventory(model)
      .subscribe((data: any) => {
        this.transactionId = parseInt(data.responseId);
        let msg = '';
        if (data != null && data.message != null) {
          if (data.extraData === true) {
            msg = 'Adjust Transaction # ' + data.message + ' is pending approval.';
          } else {
            msg = 'Adjust Inventory Transaction # ' + data.message + ' has been processed successfully.';
          }
        } else {
          msg = 'Error';
        }
        this._layoutComponent.openPopup({
          title: 'Alert',
          message: msg,
          returnAfterOkCloseClick: true,
          withoutConfirm: true
        });

        this._uploadedStream = [];
        this._selectedExistingFiles = [];
        this._selectedDocumentsKeys = [];
        if (this.upload) {
          this.upload.clearFiles();
        }

        if (this._printReceipt.value) {
          if (this._settingsPrintReceipt?.adjustTransactionReportId > 0) {
            this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: this._settingsPrintReceipt.adjustTransactionReportId, transactionId: this.transactionId });
            this._onClear();
          }
          else {
            this._reportService.ReportsByCategoryAllSitesOnly('adjustInventoryHistory', false).subscribe(
              (x: any) => {
                this._adjustInventoryReports = x;
              });
            this._printReceiptReport();
          }
        }
        else {
          this._onClear();
          this._initForm();
        }
      });
  }
  closeReport() {
    this._showReports = false;
  }

  _removeHandler({ sender, dataItem }: any) {
    this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.rowindex != dataItem.rowindex);
  }


  _onQuantityChange(e: any, item: ReceiveTransaction) {
    item.quantity = e;

    if (item.itemType === 'serial') {
      this.generateBarcode(e)
        .subscribe((data: any) => {
          item.inventoryCode = data.result.toString();
        });
    }
  }

  _onInventoryCodeChange(e: any, item: ReceiveTransaction) {
    item.inventoryCode = e;
  }
  onBlurs(e: any, item: any): void {
  }

  onFocus(e: any, item: any): void {
  }

  onOpen(e: any, item: any): void {
  }

  onClose(e: any, item: any): void {
  }


  _onExpirationDateChange(e: any, item: any) {
    if (e !== undefined) {
      // this.expDate = e
      item.expDate = e;
    } else {
    }
    // this._expirationDate.setValue(e)
  }

  _onNewQtyChange(element: NumericTextBoxComponent, e: any, item: any) {
    if (e == null) {
      element.value = 0;
      e = 0;
    }
    item.newQty = e;
    if (item.itemTypeId == 2 && (e !== 1 && e !== 0)) {
      item.newQty = null;
      e = null;
      // this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.rowindex == item.rowindex
      // ).map((obj: any, i) => ({
      //   ...obj, newQty: null
      // }));

    }

  }

  _openForm(formName: string) {
    // this._layoutComponent.openDialogForm(formComponentMapOptions[formName]);
  }

  _onClear(onAddGrid: boolean = false) {
    //this.transactionId = null;
    this._inventoryCode.setValue(null);
    this._fromLocation.setValue(null);
    this._fromLocation.disable();
    this._quantity.setValue(null);
    this._quantity.disable();
    this._expirationDate.setValue(null);
    this._expirationDate.disable();
    this._printReceipt.setValue(null);
    this.showReports = false;
    if (!onAddGrid) {
      this._inventoryGridData = [];
      this._uploadedStream = [];
      this._selectedExistingFiles = [];
      this._selectedDocumentsKeys = [];
      if (this.upload) {
        this.upload.clearFiles();
      }
    }
  }

  _initBarCodePopupForm() {
    if (!this._barcodePopupActive) {
      let inventoryValues: any[] = [];
      if (this._inventoryCode.value) {
        inventoryValues = this._inventoryCode.value.split(', ');
      }

      let record: any = {};
      for (let i = 0; i < this._quantity.value?.toFixed(this.digitNumber); i++) {
        record['field' + i] = inventoryValues[i] ? [inventoryValues[i], Validators.required] : [null, Validators.required];
        this._barcodePopupFormFields.push('field' + i);
      }

      this._barcodePopupForm = this._fb.group(record);
      this._barcodePopupActive = true;
      this._layoutManager.applyOverly();
    }
  }

  _barcodePopupClose() {
    this._barcodePopupFormFields = [];
    this._barcodePopupActive = false;
    this._layoutManager.removeOverlay();
  }

  _onBarcodePopupClear(field?: string) {
    if (field) {
      this._barcodePopupForm.get(field).setValue(null);
    } else {
      this._barcodePopupForm.reset();
    }
  }

  _onBarcodePopupSave() {
    let counter = 0;
    let inventoryCode = '';
    Object.keys(this._barcodePopupForm.controls).forEach(key => {
      if (counter > 0) {
        inventoryCode += ', ';
      }

      let fieldValue = this._barcodePopupForm.get(key).value;
      if (fieldValue) {
        inventoryCode += fieldValue;
      }

      counter++;
    });

    this._inventoryCode.setValue(inventoryCode);
    this._barcodePopupClose();

    this._quantitySubmited();
  }

  _barcodePopupGenerateBarcode(field?: string) {
    if (!field) {
      for (const key in this._barcodePopupForm.controls) {
        if (!this._barcodePopupForm.get(key).value) {
          field = key;
          break;
        }
      }
    }

    if (field) {
      this.generateBarcode(1)
        .subscribe((data: any) => {
          this._barcodePopupForm.get(field).setValue(data.result.toString());
        });
    }
  }

  private runGenerateBarcode(item: StockItemSummary = null) {
    let counter = this._itemType === 'serial' ? this._quantity.value?.toFixed(this.digitNumber) : 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._inventoryCode.setValue(data.result.toString());
        if (item != null) {
          if (item.itemType.id == 1) {
            this._expirationDate.setValue(null);
            this._expirationDate.disable()
          } else {
            this._expirationDate.enable()
            this._gridExpDate = true
            this.isStandardType = true

          }

          let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);
          if (!gridItem) {
            this._inventoryGridData.push({
              stockItemId: item.id,
              itemNumber: item.number,
              description: item.description,
              quantity: this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0,
              uom: item.receiveUnitOfMeasure.code,
              inventoryCode: this._inventoryCode.value,
              expirationDate: this._expirationDate.value,
              unitCost: item.costInfo?.cost,
              itemType: this.getItemType(item.itemType.name),
              itemTypeId: item.itemType.id,
              minQuantity: item.minqty,
              maxQuantity: item.maxqty
            });
          }
        }
      });
  }



  private checkInventoriesValiation(): boolean {
    // for (let item of this._inventoryGridData) {
    // if (item.itemTypeId === ItemsTypes.Standard) {
    //     if (item.currentQty <= 0) {
    //         return false;
    //     }
    // }

    // if (item.itemTypeId  === ItemsTypes.NonInventory) {
    //     if (item.currentQty <= 0 || !item.inventoryCode) {
    //         return false;
    //     }
    // }

    // if (item.itemTypeId  !== ItemsTypes.NonInventory && item.itemTypeId !== ItemsTypes.Standard
    //     && item.itemTypeId !== ItemsTypes.Batch
    //     && item.itemTypeId !== ItemsTypes.Serial && item.itemTypeId !== ItemsTypes.SerialwithQuantity) {
    //     if (item.currentQty <= 0 || !item.inventoryCode) {
    //         return false;
    //     }
    // }
    // }

    return true;
  }

  private getItemType(itemTypeName: string) {
    switch (itemTypeName) {
      case 'Standard':
        return 'standard';
      case 'Serial':
        return 'serial';
      case 'Batch':
        return 'batch';
      case 'Non Inventory':
        return 'non-inventory';
      case 'Serial with Quantity':
        return 'serial-with-quantity';
    }
  }

  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('inventories', quantity);
  }

  private _initForm() {
    this._form = this._fb.group({
      date: [new Date(), this.getLabel('LBL_AdjustTransactionDateTime')?.isRequired ? Validators.required : null],
      note: ['', this.getLabel('LBL_AdjustTransactionNotes')?.isRequired ? Validators.required : null],
      site: [null]
    });
    this.getDateEnabledOption();

    if (!this._currentUser.isEnterprise) {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";

      if (loggedInAccountSites != "") {
        var siteId = JSON.parse(loggedInAccountSites)[0].siteId;

        if (!siteId) {
          this.router.navigate(['/']);
        }

        this._form.patchValue({
          site: siteId
        });

        this._loadInventories(siteId);
      }
    }
  }

  _quantityListSubmited(_stockitem: any[]) {
    _stockitem.forEach(control => {
      if (control) {
        this.fillGridMulitableRowsSelect(control);
      }
    });
    this._selectedInventoryItem.setValue(null);
    this.selectfromfetchall = false;
    this._selectedInventoriesFromGrid = null;
    this._invalidForm = false;
    this._additionalErrors = [];

  }




  private fillGridMulitableRowsSelect(_stockitem: any) {
    this.maxToMove = Number.MAX_VALUE;
    let gridItem = this._inventoryGridData.find(x => x.inventoryCode === _stockitem.inventoryNumber
      && x.locationId === _stockitem.location.id);
    let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;
    if (!gridItem || (gridItem && _stockitem.stockItem.itemType
      && _stockitem.stockItem.itemType.name.toLocaleLowerCase() == 'batch')) {
      this._quantity.setValue(_stockitem.stockItem.itemType.id == ItemsTypes.Serial ? 1 : 0);
      this._inventoryGridData.push({
        inventory: _stockitem,
        fromLocationId: 0,
        rowindex: maxrowindex,
        id: _stockitem.id,
        inventoryCode: _stockitem.inventoryNumber,
        stockItemId: _stockitem.stockItem.id,
        siteId: this._form.controls.site.value.id,
        currentAvailableQuantity: _stockitem?.availability?.toFixed(this.digitNumber),
        inventoryNumber: _stockitem.inventoryNumber,
        itemNumber: _stockitem.stockItem.number,
        description: _stockitem.stockItem.description,
        quantity: _stockitem.availableQuantity,
        quantityMoved: this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0,

        expDate: _stockitem?.expirationDate != null ? new Date(_stockitem?.expirationDate) : null,
        entryDate: this._form.controls.date.value,
        location: _stockitem.itemLocations,
        selectedFromLocation: _stockitem.itemLocations.find((r: any) => r.id == _stockitem.locationId),
        stockNumber: _stockitem.stockItem.number,
        stockId: _stockitem.stockItem.id,
        udField1: _stockitem.udField1,
        udField2: _stockitem.udField2,
        udField3: _stockitem.udField3,
        udFieldDate1: _stockitem.udFieldDate1 != null ? new Date(_stockitem.udFieldDate1) : null,
        udFieldDate2: _stockitem.udFieldDate2 != null ? new Date(_stockitem.udFieldDate2) : null,
        udFieldDate3: _stockitem.udFieldDate3 != null ? new Date(_stockitem.udFieldDate3) : null,
        currentQty: _stockitem?.availability?.toFixed(this.digitNumber),
        fromLocationFiltered: _stockitem.itemLocations,
        availability: _stockitem?.availableQuantity?.toFixed(this.digitNumber),
        minQuantity: _stockitem.minQuantity,
        maxQuantity: _stockitem.maxQuantity,
        itemType: _stockitem.stockItem.itemType.name,
        itemTypeId: _stockitem.stockItem.itemType.id,
        selectfromfetchall: this.selectfromfetchall,
        newQty: this.selectfromfetchall == true && _stockitem.stockItem.itemType.id == ItemsTypes.Serial ? 0 : null,
        stocklocation: _stockitem.stockLocation

      });
    } else {
      this._selectedInventoryItem.setValue(null);
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'This item is already added to the grid. Please select another item.',
        returnAfterOkCloseClick: true,
        withoutConfirm: true
      });
    }
  }


  private fillGrid() {
    let currentQty: any = 0;
    let item = this._selectedInventoryItem.value;
    if (item.stockItem.itemType.id == 1) {
      this._gridExpDate = true
      this.isStandardType = true
      this.expDate = null
      this._expirationDate.setValue(null)
      this._expirationDate.disable()
    } else {
      this._expirationDate.enable()
      this._gridExpDate = true
      this.isStandardType = true

    }
    let gridItem = this._inventoryGridData.find(x => x.id === item.id && x.location === this._fromLocation.value.code);
    let inventory = this._inventoriesFiltered
    if (!gridItem) {
      if (this.isStandardType) {
        currentQty = this._fromLocation.value.availability?.toFixed(this.digitNumber);
      }
      else {
        currentQty = this._fromLocation.value.availability?.toFixed(this.digitNumber) ? this._fromLocation.value.availability?.toFixed(this.digitNumber) : this._inventoryCode.value.availability;
      }
      let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;
      this._inventoryGridData.push({
        rowindex: maxrowindex,
        newQty: this._quantity.value,
        id: this._inventoryCode.value.id,
        inventoryCode: this._inventoryCode.value.inventoryNumber,
        expirationDate: item.stockItem.itemType.id == 1 ? null : this._expirationDate.value ?? this.expDate != null ? new Date(this.expDate) : null,
        location: item.itemLocationsFiltered,
        locationId: this._fromLocation.value.id,
        currentQty: currentQty,
        udField1: this.inventoryById?.udField1,
        udField2: this.inventoryById?.udField2,
        udField3: this.inventoryById?.udField3,
        udFieldDate1: this.inventoryById?.udFieldDate1 != null ? new Date(this.inventoryById?.udFieldDate1) : null,
        udFieldDate2: this.inventoryById?.udFieldDate2 != null ? new Date(this.inventoryById?.udFieldDate2) : null,
        udFieldDate3: this.inventoryById?.udFieldDate3 != null ? new Date(this.inventoryById?.udFieldDate3) : null,
        description: this._inventoryCode.value.stockItem.description,
        stockId: this._inventoryCode.value.stockItem.id,
        stockNumber: this._inventoryCode.value.stockItem.number,
        expDate: item.stockItem.itemType.id == 1 ? null : this._expirationDate.value ?? this.expDate != null ? new Date(this.expDate) : null,
        note: this._form.value.note,
        itemTypeId: item.stockItem.itemType.id,
        selectedFromLocation: item.itemLocations.find((r: any) => r.id == this._fromLocation.value.id),

        //              newQty: this.selectfromfetchall == true &&  _stockitem.stockItem.itemType.id == ItemsTypes.Serial ? 0 : null,
        // stocklocation :_stockitem.stockLocation

      });
      //       if(this.isStandardType)
      //       {
      //this._fromLocation.value.availability?.toFixed(this.digitNumber),
      //       }
      //       else
      //       {
      //       this._inventoryGridData.push({
      //         newQty: this._quantity.value,
      //         id:this._inventoryCode.value.id,
      //         inventoryCode: this._inventoryCode.value.inventoryNumber,
      //         expirationDate: this._expirationDate.value,
      //         location: item.itemLocationsFiltered ,
      //         locationId: this._fromLocation.value.id,

      //         currentQty: this._fromLocation.value.availability?.toFixed(this.digitNumber) ? this._fromLocation.value.availability?.toFixed(this.digitNumber) : this._inventoryCode.value.availability,

      //         description: this._inventoryCode.value.stockItem.description,
      //         stockId: this._inventoryCode.value.stockItem.id,
      //         stockNumber: this._inventoryCode.value.stockItem.number,
      //         expDate: this._expirationDate.value,
      //         note: this._form.value.note,
      //         itemTypeId :  item.itemTypeId,
      //          fromLocationFiltered: item.itemLocations,
      //     });
      //   }
      this._selectedInventoryItem.setValue(this._inventoryGridData.values);
      this._fromLocation.setValue(null)
      this._fromLocation.disable();
    }
    else {
      this._selectedInventoryItem.setValue(null);
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'This item is already added to the grid. Please select another item.',
        returnAfterOkCloseClick: true,
        withoutConfirm: true
      });
    }

  }

  isOpened: boolean = false;
  timeOut: any;
  clearTimeout: any;
  beginScroll: boolean = false;

  onBlur() {
    this.beginScroll = false;
    this._inventories = [];
    this._inventoriesFiltered = [];
    this.comboBoxpagingationParams.currentItem = '0';
    var siteId = this._form.get('site').value;
    this._loadInventories(siteId);
  }


  scrollCombobox(event: any) {
    this.isOpened = true;
    this.beginScroll = false;
    if (this.isOpened) {
      this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e: any) => {
        if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
          this.beginScroll = true;
          this.comboBoxpagingationParams.currentItem = (parseInt(this.comboBoxpagingationParams.currentItem) + this.comboBoxpagingationParams.totalbyPage).toString();
          var siteId = this._form.get('site').value;
          this._loadInventories(siteId);
        }
      });
    }

  }


  filterarray: any = [];
  _loadInventories(siteId: number) {
    if (!this.beginScroll) {
      this.comboBoxpagingationParams = {
        currentItem: '0',
        totalbyPage: 20,
        search: this.comboBoxpagingationParams.search != '' ? this.comboBoxpagingationParams.search : '',
        page: 1,
        pagenumber: 1
      };

      return this._inventoriesService.getInventoryListing2(siteId, this.comboBoxpagingationParams, true)
        .subscribe((data: any) => {
          this._inventoriesFiltered = data.body;
          this._inventoriesFiltered = this._inventoriesFiltered.filter((item, i, arr) => arr.findIndex(t => t.inventoryNumber === item.inventoryNumber) === i);
        });


    } else {
      if (this.comboBoxpagingationParams.page == 1) this.comboBoxpagingationParams.page = 3;
      return this._inventoriesService.getInventoryListing2(siteId, this.comboBoxpagingationParams, true)
        .subscribe((data: any) => {
          if (data.body.length) {
            if (this._inventoriesFiltered.length) {
              data.body.forEach((a: any) => {
                let resualt = this._inventoriesFiltered.find((d: any) => d.inventoryNumber === a.inventoryNumber);
                if (resualt === undefined) {
                  this.filterarray.push(data.body.find((d: any) => d.inventoryNumber === a.inventoryNumber));
                }

              });
              this._inventoriesFiltered = [...this._inventoriesFiltered, ...this.filterarray];

              this.filterarray = [];

              if (this.comboBoxpagingationParams != null)
                this.comboBoxpagingationParams.page += 1;

            }

          }
        });
    }

  }

  _loadInventoriesXXXX(siteId: number) {
    return this._inventoriesService.getInventoryListing(siteId)
      .subscribe((data) => {
        data = data.filter(x => x.availability != 0);
        this._inventoriesallitems = data; //
        this._inventories = data.filter((item, i, arr) => arr.findIndex(t => t.inventoryNumber === item.inventoryNumber) === i);

        this._inventoriesFiltered = data.filter((item, i, arr) => arr.findIndex(t => t.inventoryNumber === item.inventoryNumber) === i);
      });
  }
  _handleInventoriesFilterxxxx(value: any) {
    this._inventoriesFiltered = this._inventories.filter(
      (s) => s.inventoryNumber.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _handleInventoriesFilter(value: any) {
    this.beginScroll = false;
    if (this.timeOut) clearTimeout(this.timeOut);
    var doneTypingInterval = 10;
    this.timeOut = setTimeout(() => {
      this.comboBoxpagingationParams.search = value;
      this.comboBoxpagingationParams.currentItem = '0';
      this.comboBoxpagingationParams.pagenumber += 1;
      var siteId = this._form.get('site').value;

      if (this._model != null && this._model.id != null && this._model.site != null && this._model.site.id != null) {
        this._loadInventories(this._model.site.id);
      }
      else {
        this._loadInventories(siteId);
      };
    }, doneTypingInterval);

  }

  isStandardType: boolean = false;

  _handleInventoriesChangeXXXXXXXXXXXXX(value: any) {
    setTimeout(() => {
      if (value) {
        this._inventoriesService.getInventoryById(value.id)

          .subscribe((data) => {

            this._fromLocation.setValue(null);
            this.itemFormLocationsFiltered = [];
            let _itemLocations = [...data.itemLocations];
            this.itemFormLocationsFiltered = _itemLocations;
            this.itemFormLocations = _itemLocations;

            this._inventoriesallitems = data.stockLocation;

            let locAvailabilityMap = new Map<number, number>();
            if (data.inventoryNumber == value.inventoryNumber) {
              locAvailabilityMap.set(data.locationId, data.availability);
            }
            data.itemLocations?.forEach((loc: any) => {
              loc.availability = locAvailabilityMap.get(loc.id);
            });

            if (this._selectedInventoriesFromGrid && this._selectedInventoriesFromGrid.length > 0) {
              this._selectedInventoryItem.setValue({
                ...this._selectedInventoriesFromGrid[0],
                itemLocations: data.itemLocations,
                itemFormLocationsFiltered: data.itemLocations,
                itemType: data.stockItem.itemType,
                availability: data.availability,
                expirationDate: data.expirationDate,
                id: data.id,
                stockItem: data.stockItem
              });
              let inventoryObject: any = this._inventoriesFiltered.find(x => x.id == data.id);
              this._inventoryCode.setValue(inventoryObject);
              this._selectedInventoriesFromGrid = [];
            }
            else {
              this._selectedInventoryItem.setValue({
                ...this._selectedInventoryItem.value,
                itemLocations: data.itemLocations,
                itemFormLocationsFiltered: data.itemLocations,
                availability: data.availability,
                itemType: data.stockItem.itemType,
                expirationDate: data.expirationDate,
                stockItem: data.stockItem,
                id: data.id
              });

            }
            if (value.stockItem.itemType.id == 2) {
              this._fromLocation.setValue(this._selectedInventoryItem.value?.itemLocationsFiltered[0]);
              this._quantity.setValue(value.availability);
              this._quantitySubmited();
            }
            else {
              this.kendoComboFromLocation.focus();
              this.kendoComboFromLocation.toggle(true);
            }

          });
      }
    });
  }
  expDate: any;
  inventoryById: any;
  _handleInventoriesChange(value: any) {

    if (value) {
      this._inventoriesService.getInventoryById(value.id, null, true)

        .subscribe((data) => {
          this.inventoryById = data
          if (data.stockItem.itemType.id == 1) {
            this._gridExpDate = true
            this.isStandardType = true
            this.expDate = null
            this._expirationDate.setValue(null)
            this._expirationDate.disable()
          } else {
            this.expDate = data.expirationDate;
            this._expirationDate.setValue(data.expirationDate != null ? new Date(data.expirationDate) : null)
            this._expirationDate.enable()
            this._gridExpDate = true
            this.isStandardType = true
          }
          this._fromLocation.setValue(null);
          this.itemFormLocationsFiltered = [];
          data.itemLocations = data.itemLocations.filter((x: any) => x.siteId == this._form.controls['site'].value);
          let _itemLocations = [...data.itemLocations];
          _itemLocations = _itemLocations.map((obj: any, i) => ({
            ...obj, stockitems: data.stockItem
          }));

          this.itemFormLocationsFiltered = _itemLocations;
          this.itemFormLocations = _itemLocations;
          this._inventoriesallitems = data.stockLocation;

          let locAvailabilityMap = new Map<number, number>();
          let resu = this._inventoriesallitems.filter((x: any) =>
            x.inventoryNumber == value.inventoryNumber);

          resu.forEach(inv => {
            if (inv.inventoryNumber == value.inventoryNumber) {
              let sumofavailability = resu.filter((x: any) => x.locationId === inv.locationId)
                .map(a => a.availability);
              let sum = sumofavailability.reduce((accu, curr) => accu + curr);
              locAvailabilityMap.set(inv.locationId, sum);
            }
          });

          data.itemLocations?.forEach((loc: any) => {
            loc.availability = locAvailabilityMap.get(loc.id);
          });

          if (this._selectedInventoriesFromGrid && this._selectedInventoriesFromGrid.length > 0) {

            this._selectedInventoryItem.setValue({
              ...this._selectedInventoriesFromGrid[0],
              itemLocations: data.itemLocations,
              itemLocationsFiltered: data.itemLocations,
              availability: data.availability
            });
            this._selectedInventoriesFromGrid = [];


          }
          else {
            this._selectedInventoryItem.setValue({
              ...this._selectedInventoryItem.value,
              itemLocations: data.itemLocations,
              itemLocationsFiltered: data.itemLocations,
              availability: data.availability,
              stockLocation: data.stockLocation,
              stockItem: data.stockItem
            });
          }

          if (value.stockItem.itemType.name == 'Serial') {
            this._fromLocation.setValue(this._selectedInventoryItem.value?.itemLocationsFiltered[0]);
            this._quantity.setValue(value.availability);
            this._quantitySubmited();

          }
          else {

            data.itemLocations = data.itemLocations.map((obj: any) => ({
              ...obj, stockitems: data.stockItem
            }));

            this.itemFormLocationsFiltered = data.itemLocations;
            this.itemFormLocations = data.itemLocations;
            this.kendoComboFromLocation.focus();
            this.kendoComboFromLocation.toggle(true);
          }

        });
    }

    else {

      this._fromLocation.setValue(null);
      this._fromLocation.disable();
      this._quantity.setValue(0.0000);
      this._quantity.disable();
      this._expirationDate.setValue(null);
      this._expirationDate.disable();
    }

    if (value == undefined) {
      this._fromLocation.setValue(null);
      this._fromLocation.disable();
      this._quantity.setValue(0.0000);
      this._quantity.disable();
      this._expirationDate.setValue(null);
      this._expirationDate.disable();
      this.kendoComboFromLocation.toggle(false);
    }
    ;
  }

  selectfromfetchall: boolean
  _returnSelectedInventoriessHandler(e: any[]): void {
    this._showInventoriesGrid = false;
    if (this._selectedInventoriesFromGrid.length > 0) {
      this.selectfromfetchall = true
      this._handleInventoriesListChange(this._selectedInventoriesFromGrid);
    }

  }


  _handleInventoriesListChange(listofIds: any[]) {
    let stringparam: string = '';
    let value: any;
    let all = listofIds.map((x: any) => x.id);
    let resu: any;
    all.forEach((a: string) => {
      stringparam = stringparam + a.toString().concat(',');
    });
    stringparam = stringparam.slice(0, stringparam.length - 1);
    const params = {
      ids: stringparam,
      param: true
    }
    this._inventoriesService.getInventoryListIdsParam(params)

      .subscribe((data) => {
        data.filter((x: any) => x.availability != undefined);
        let listinventorystockitems: any[] = [];
        if (this._selectedInventoriesFromGrid && this._selectedInventoriesFromGrid.length > 0) {
          let count: number = 1;
          data.forEach((item: any) => {

            listinventorystockitems.push({
              ...item,
              itemLocations: item.itemLocations,
              itemLocationsFiltered: item.itemLocations,
              location: item.location,
              availability: item.availability,
              serial: count
            });
            count += 1;
          });
          this._quantityListSubmited(listinventorystockitems);

        }

      });
  }


  _onInventoryRowSelectionChanges(e: any[]) {
    this._selectedInventoriesFromGrid = [];
    e.forEach((item) => {
      this._selectedInventoriesFromGrid.push(item);
    });
  }
  _selectInventoriesHandler() {
    if (this._currentUser.isEnterprise && !this._selectedAccount.value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select Account',
        withoutConfirm: true
      });
    } else {
      this._showInventoriesGrid = true;
    }
  }
  _getInventoryItems = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {

    if (model != null && model.filter != null && this._form.get('site').value != null) {
      model.SiteId = this._form.get('site').value.id;
      model.withoutavaliability = true;
      return this._inventoriesService.getInventories(params, model);


    }
  }
  _closeInventoriesWindow(): void {
    this._showInventoriesGrid = false;
  }

  _handleFromLocationsFilter(value: any, dataItem: any) {
    dataItem.fromLocationFiltered = dataItem.fromLocation.filter(
      (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleFromLocationChange(value: any, dataItem: any) {

    if (value) {
      let resualtlocation = this._inventoryGridData.filter((x: any) =>
        x.inventoryCode == dataItem.inventoryCode).map((a: any) => a.location).shift();

      let locationavailability = resualtlocation.filter((m: any) => m.id == value.id).shift()
      dataItem.currentQty = (0).toFixed(this.digitNumber);
      dataItem.fromLocationId = value.id;
      dataItem.newQty = '';
      dataItem.currentQty = locationavailability ? locationavailability.availability?.toFixed(this.digitNumber) : 0;

      if (locationavailability.availability == undefined) {
        dataItem.currentQty = dataItem.stocklocation.filter((x: any) => x.locationId === value.id).map((a: any) => a.availability).shift();

        dataItem.fromLocationId = value.id;
        dataItem.newQty = '';
      }
    }
    if (value == undefined) {
      dataItem.newQty = '';
      dataItem.currentQty = '';
    }
  }

  _formLocationValueChange() {
    if (this._fromLocation.value) {
      let expDate = this._selectedInventoryItem.value.expirationDate;
      let itemTypeId = this._inventoryCode.value.stockItem.itemType.id;

      //  if (itemTypeId === ItemsTypes.Standard || itemTypeId === ItemsTypes.NonInventory) {
      if (itemTypeId == ItemsTypes.Standard) {
        this._gridExpDate = true;
        this.isStandardType = true
        this.expDate = null
        this._expirationDate.setValue(null)
        this._expirationDate.disable()
        //   if (expDate != null) {
        //   } else {
        //     this._expirationDate.setValue(new Date(Date.now()));
        //     this._expirationDate.setValue(new Date(Date.now()));
        //   }
      } else {
        this._expirationDate.setValue(expDate != null ? new Date(expDate) : null)
        this._expirationDate.enable()
        this.isStandardType = false
        this._gridExpDate = false;
      }
      setTimeout(() => {
        this.quantityInput.focus();
      }, 100);


    }
  }

  _quantityValueChange() {
    if (this._quantity.value >= 0) {
      // let itemType = this._inventoryCode.value.stockItem.itemType.id;
      // if (itemType === ItemsTypes.Standard  || itemType === ItemsTypes.NonInventory  ) {
      // this._quantitySubmited();
      // } else {
      //     setTimeout(() => {
      //         this.kendoDateTimePickerExpDate.focus();
      //     }, 100);
      // }
    }
    this._quantitySubmited();
  }

  _getReceiveSettings() {
    this._sysReceivesService
      .getSysReceive()

      .subscribe((data: any) => {
        if (data != null) {
          this._receiveUDField1Show = data.udField1;
          this._receiveUDField2Show = data.udField2;
          this._receiveUDField3Show = data.udField3;
          this._receiveUDFieldDate1Show = data.udFieldDate1;
          this._receiveUDFieldDate2Show = data.udFieldDate2;
          this._receiveUDFieldDate3Show = data.udFieldDate3;
        }
      });
  }


  _onUDFieldChange(e: any, item: any, udField: string) {
    switch (udField) {
      case "uDField1":
        item.uDField1 = e.target.value;
        break;
      case "uDField2":
        item.uDField2 = e.target.value;
        break;
      case "uDField3":
        item.uDField3 = e.target.value;
        break;
      case "uDFieldDate1":
        item.uDFieldDate1 = e;
        break;
      case "uDFieldDate2":
        item.uDFieldDate2 = e;
        break;
      case "uDFieldDate3":
        item.uDFieldDate3 = e;
        break;
      default:
        break;
    }
  }

  //#region  EditForm
  _editFormState() {
    this._pageState = PageState.EDIT_FIELDS;
  }

  _returnAddNew() {
    this._pageState = PageState.ADD;
  }
  //#endregion
  _openRenameForm(objectCode: string, isMandatory: boolean = false, onlyRequired: boolean = false, hasRequired: boolean = false) {
    this._selectedLabelObjectCode = objectCode;
    //todo send system field label id
    //return;
    //open form once label id is set
    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
    this._isTransaction = true;
    this._onlyRequired = onlyRequired;
    this._hasRequired = hasRequired;
  }

  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    // this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();
    // this.getFormTabs();
    this.getAuth();
    this._isTransaction = false;
    this._onlyRequired = false;
    this._hasRequired = false;
  }

  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      })
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
        //   result.text = 'Adjust Date'
      } else
        result = null

      return result ? result : null;
    }
    //return 'Adjust Date'
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : new GridFieldAuthorization();
    }
  }

  getCustomerAuth() {
    this._gridFields.getFileAuthorization('mnuStockCustomer', this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization) => {
        this._customerAuth = x;
      });
  }

  getSalesOrderAuth() {
    this._gridFields.getFileAuthorization('mnuStockSalesOrder', this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization) => {
        this._salesOrderAuth = x;
      });
  }

  _printReceiptReport() {
    // var reportId = this.selectReceiptReport.value.id;
    this._printReceiptsService
      .getPrintReceipt()
      .subscribe((data) => {
        var reportId = data.adjustTransactionReportId
        if (reportId > 0) {
          this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: reportId, transactionId: this.transactionId });
          this._onClear();
        } else {
          this._showReports = true;
          this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: this.selectReceiptReport.value.id, transactionId: this.transactionId });
          this._onClear();
          // this._printReceiptReport()
        }
      });

  }

  _getSysIssue() {
    this._sysIssuesService
      .getSysIssue()

      .subscribe((data) => {
        this._sysIssue = data;
      });
  }

  getDateEnabledOption() {
    this._TransactionDateEditting.getTransactionDateEditing("get-data")

      .subscribe((x: any) => {
        if (x != null && x != undefined) {
          this._dateEnabled = x.transactionDateEditing;
          if (!this._dateEnabled) {
            this._form.get('date')?.disable();
          }
        }
      })
  }

}
